var map = {
	"./Aatrox.png": 87,
	"./Ahri.png": 88,
	"./Akali.png": 89,
	"./Anivia.png": 90,
	"./Ashe.png": 91,
	"./AurelionSol.png": 92,
	"./Blitzcrank.png": 93,
	"./Brand.png": 94,
	"./Braum.png": 95,
	"./Chogath.png": 96,
	"./Darius.png": 97,
	"./Draven.png": 98,
	"./Elise.png": 99,
	"./Evelynn.png": 100,
	"./Fiora.png": 101,
	"./Gangplank.png": 102,
	"./Garen.png": 103,
	"./Gnar.png": 104,
	"./Graves.png": 105,
	"./Karthus.png": 106,
	"./Kassadin.png": 107,
	"./Katarina.png": 108,
	"./Kayle.png": 109,
	"./Kennen.png": 110,
	"./Khazix.png": 111,
	"./Kindred.png": 112,
	"./Leona.png": 113,
	"./Lissandra.png": 114,
	"./Lucian.png": 115,
	"./Lulu.png": 116,
	"./MissFortune.png": 117,
	"./Mordekaiser.png": 118,
	"./Morgana.png": 119,
	"./Nidalee.png": 120,
	"./Poppy.png": 121,
	"./Pyke.png": 122,
	"./RekSai.png": 123,
	"./Rengar.png": 124,
	"./Sejuani.png": 125,
	"./Shen.png": 126,
	"./Shyvana.png": 127,
	"./Swain.png": 128,
	"./Tristana.png": 129,
	"./TwistedFate.png": 130,
	"./Varus.png": 131,
	"./Vayne.png": 132,
	"./Veigar.png": 133,
	"./Volibear.png": 134,
	"./Warwick.png": 135,
	"./Yasuo.png": 136,
	"./Zed.png": 137,
	"./bladeoftheruinedking.png": 138,
	"./bloodthirster.png": 139,
	"./cursedblade.png": 140,
	"./darkin.png": 141,
	"./dragonsclaw.png": 142,
	"./forceofnature.png": 143,
	"./frozenheart.png": 144,
	"./frozenmallet.png": 145,
	"./guardianangel.png": 146,
	"./guinsoosrageblade.png": 147,
	"./hextechgunblade.png": 148,
	"./hush.png": 149,
	"./infinityedge.png": 150,
	"./ionicspark.png": 151,
	"./knightsvow.png": 152,
	"./locketoftheironsolari.png": 153,
	"./ludensecho.png": 154,
	"./map_default.jpg": 155,
	"./morellonomicon.png": 156,
	"./needlesslylargerod.png": 157,
	"./phantomdancer.png": 158,
	"./rabadonsdeathcap.png": 159,
	"./rapidfirecannon.png": 160,
	"./redbuff.png": 161,
	"./redemption.png": 162,
	"./runaanshurricane.png": 163,
	"./seraphsembrace.png": 164,
	"./spatula.png": 165,
	"./spearofshojin.png": 166,
	"./statikkshiv.png": 167,
	"./swordbreaker.png": 168,
	"./swordofthedivine.png": 169,
	"./thornmail.png": 170,
	"./titanichydra.png": 171,
	"./warmogsarmor.png": 172,
	"./youmuusghostblade.png": 173,
	"./yuumi.png": 174,
	"./zekesherald.png": 175,
	"./zephyr.png": 176
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86;